/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ValueTuple_BackgroundValidationResponseDto_List_1_List_1_List_1 } from '../models/ValueTuple_BackgroundValidationResponseDto_List_1_List_1_List_1';
import type { Wealthlane_AwardService_Dtos_TADRSInstruction_TADRSInstructionResponseDto } from '../models/Wealthlane_AwardService_Dtos_TADRSInstruction_TADRSInstructionResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';
import type { Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo } from '../models/Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ImportTaDrsService {

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppImportTaDrsImportDrsInstruction(
formData?: {
File: Blob;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/import-ta-drs/import-drs-instruction',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taskId 
     * @param tenantId 
     * @param userId 
     * @param taskInstruction 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppImportTaDrsHandleDrsInstructionImport(
taskId?: string,
tenantId?: string,
userId?: string,
taskInstruction?: string,
requestBody?: Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/import-ta-drs/handle-drs-instruction-import',
            query: {
                'taskId': taskId,
                'tenantId': tenantId,
                'userId': userId,
                'taskInstruction': taskInstruction,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns ValueTuple_BackgroundValidationResponseDto_List_1_List_1_List_1 OK
     * @throws ApiError
     */
    public static postApiAwardApiAppImportTaDrsValidateDrsInstruction(
requestBody?: Array<Wealthlane_AwardService_Dtos_TADRSInstruction_TADRSInstructionResponseDto>,
): CancelablePromise<ValueTuple_BackgroundValidationResponseDto_List_1_List_1_List_1> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/import-ta-drs/validate-drs-instruction',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
